import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { NavLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Collapse,
  CssBaseline,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Divider,
  Badge
} from '@mui/material';
import {
  ExpandCircleDownRounded,
  ExpandLess,
  ExpandMore,
  KeyboardDoubleArrowLeftRounded,
  KeyboardDoubleArrowRightRounded,
  Logout,
  Receipt,
  PendingActions,
  RequestPage,
  PersonOutlineOutlined,
  EmailOutlined
} from '@mui/icons-material';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
// import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { useDispatch, useSelector } from 'react-redux';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { Scrollbars } from 'react-custom-scrollbars-2';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import DrawIcon from '@mui/icons-material/Draw';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
// import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import Header from './Header';
import AuthAction from '../store/actions/AuthAction';
import LogoSymbol from '../assets/images/logo_velan.png';
import Logo from '../assets/images/velan_logo_black.png';
import { getUserData } from '../utils/AuthConfig';
import Notifications from './Notifications';
import ChangePassword from '../pages/profile/changePassword';
import globalAction from '../store/actions/GlobalAction';
import SettingAction from '../store/actions/SettingAction';
import useHasPermission from '../utils/useHasPermission';
import {
  address,
  auditTrail,
  bank,
  client,
  company,
  currency,
  department,
  mail,
  paymentRequest,
  paymentSettings,
  transaction,
  signature,
  report,
  uom,
  index
  // store,
  // show,
  // update,
  // destroy
} from '../utils/constants';

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden',
  borderRight: '1px solid rgba(0, 32, 93, 0.5)!important'
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`
  }
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2, 2),
  // necessary for content to be below app bar
  // ...theme.mixins.toolbar
  minHeight: '80px'
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  marginLeft: `calc(${theme.spacing(8)} + 1px)`,
  width: `calc(100% - ${theme.spacing(8)} + 1px)`,
  left: '0px',
  background: '#fff',
  boxShadow: 'none',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  //   background: theme.palette.primary.main,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  '& .MuiPaper-root': {
    background: '#ffffff'
  },

  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

function Sidebar({ hasPermission }) {
  const [open, setOpen] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [reportMenuOpen, setReportMenuOpen] = useState(false);
  const [clientMenuOpen, setClientMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [notifyCount, setNotifyCount] = useState(0);
  const [anchorE2, setAnchorE2] = useState(null);
  const [userData, setUserData] = useState('');
  const [hasPerm, setHasPerm] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const userInfo = getUserData();
  const handleChangePassword = () => setModalOpen(true);
  const dropDownOpen = Boolean(anchorEl);
  const notifyOpen = Boolean(anchorE2);
  /* Notification */
  const { notificationData } = useSelector((state) => state.global);
  const { profileData } = useSelector((state) => state.setting);
  const handleClick = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const hasPaymentRequestPermission = useHasPermission(paymentRequest, index);
  const hasTransactionPermission = useHasPermission(transaction, index);
  const hasAuditTrailPermission = useHasPermission(auditTrail, index);
  const hasUOMPermission = useHasPermission(uom, index);
  const hasCurrencyPermission = useHasPermission(currency, index);
  const hasClientPermission = useHasPermission(client, index);
  const hasCompanyPermission = useHasPermission(company, index);
  const hasDepartmentPermission = useHasPermission(department, index);
  const hasBankPermission = useHasPermission(bank, index);
  const hasAddressPermission = useHasPermission(address, index);
  const hasPaymentGatewayPermission = useHasPermission(paymentSettings, index);
  const hasSignaturePermission = useHasPermission(signature, index);
  const hasReportPermission = useHasPermission(report, index);
  const hasMailPermission = useHasPermission(mail, index);

  const hasRolesPermission = useHasPermission('roles_permissions', 'index');
  const hasUserPermission = useHasPermission('users', index);

  useEffect(() => {
    setHasPerm(hasPermission);
  }, [hasPermission]);

  useEffect(() => {
    if (hasPerm) {
      dispatch(globalAction.getAllNotifications());
    }
  }, [hasPerm, dispatch]);

  useEffect(() => {
    dispatch(SettingAction.getUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (notificationData) {
      setNotifyCount(notificationData.total_count);
    }
  }, [notificationData]);
  // const token = getLoggedInToken();
  // console.log(token, "token");
  useEffect(() => {
    if (profileData && profileData?.data) {
      setUserData(profileData.data);
    } else {
      setUserData(userInfo);
    }
  }, [profileData]);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  const ListItemStyle = () => ({
    py: 0.5,
    px: 1.5,
    display: 'block',
    borderTop: '2px solid rgba(255,255,255,0.075)',
    borderBottom: '2px solid rgba(255,255,255,0.075)',
    '&.dropdown': {
      borderBottom: menuOpen && 'none',
      pb: menuOpen && '0'
    },
    '.MuiListItemButton-root': {
      minHeight: 24,
      px: 1.5,
      py: 1.5,
      justifyContent: open ? 'initial' : 'center',
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.06)'
      },

      '.MuiListItemIcon-root': {
        p: 0,
        borderRadius: '50%',
        background: 'transparent',
        mr: open ? 1 : 'auto',
        minWidth: 0,
        justifyContent: 'center',
        i: {
          fontSize: '16px'
        },
        'i::before': {
          color: '#000'
        }
      },
      '.MuiListItemText-root': {
        '.MuiTypography-root': {
          opacity: open ? 1 : 0,
          color: '#000',
          fontSize: '14px',
          fontWeight: 700
        }
      },
      '.MuiSvgIcon-root': {
        color: '#000',
        fontSize: '20px'
      }
    },
    '&.active': {
      '.MuiListItemButton-root': {
        background: '#e6efff'
      },
      '.MuiListItemText-root': {
        '.MuiTypography-root': {
          color: '#1640d6'
        }
      },
      '.MuiSvgIcon-root': {
        color: '#1640d6'
      }
    }
  });

  const SubListItemStyle = () => ({
    px: 1,
    '&:last-child': {
      py: 1,
      borderBottom: '2px solid rgba(255,255,255,0.075)'
    },
    '.MuiListItemText-root': {
      '.MuiTypography-root': {
        opacity: open ? 1 : 0,
        color: '#000',
        fontSize: '14px',
        fontWeight: 700
      }
    },
    '.MuiListItemButton-root': {
      px: open ? 3 : 2.5,
      py: 0.5,
      justifyContent: open ? 'initial' : 'center',
      '.MuiListItemIcon-root': {
        minWidth: 'auto',
        px: open ? 0.5 : 0,
        '.MuiSvgIcon-root': {
          color: '#000'
        }
      }
    },
    '.MuiSvgIcon-root': {
      color: '#000',
      fontSize: '20px'
    },
    '.MuiListItem-root': {
      '&.active': {
        '.MuiListItemButton-root': {
          background: '#e6efff'
        },
        '.MuiListItemText-root': {
          '.MuiTypography-root': {
            color: '#1640d6'
          }
        },
        '.MuiSvgIcon-root': {
          color: '#1640d6'
        }
      }
    }
  });

  const handleReprtDropClick = () => {
    setReportMenuOpen(!reportMenuOpen);
  };

  const handleDropClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClientDropClick = () => {
    setClientMenuOpen(!clientMenuOpen);
  };

  const handleUserDropClick = () => {
    setUserMenuOpen(!userMenuOpen);
  };

  const handleSettingClick = () => {
    setSettingOpen(!settingOpen);
  };

  // const handleClickAway = () => {
  //   setMenuOpen(false);
  // };

  const handleDropDownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleDropDownClose = () => {
    setAnchorEl(null);
  };

  // const itemStyle = {
  //   ".MuiTypography-root": {
  //     opacity: open ? 1 : 0,
  //     color: "white",
  //     fontSize: "15px",
  //   },
  // };

  // const iconStyle = {
  //   borderRadius: "50%",
  //   background: "rgba(255,255,255, 0.3)",
  //   mr: open ? 3 : "auto",
  //   minWidth: 0,
  //   justifyContent: "center",
  //   p: 1,
  //   i: {
  //     fontSize: "18px",
  //   },
  //   "i::before": {
  //     color: "#fff",
  //   },
  // };

  // const listButtonStyle = {
  //   minHeight: 48,
  //   justifyContent: open ? "initial" : "center",
  //   px: 2.5,
  // };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}>
        <DrawerHeader
          sx={{
            p: '15px !important',
            minHeight: '80px',
            borderBottom: '1px solid rgba(0, 32, 93, 0.5)!important'
          }}
        >
          {open ? <img src={Logo} alt="Velan Logo" /> : <img src={LogoSymbol} alt="Velan Logo" />}
        </DrawerHeader>
        <Scrollbars autoHide style={{ height: '100vh' }}>
          <List sx={{ py: 2 }}>
            <ListItem component={NavLink} to="/dashboard" disablePadding sx={ListItemStyle}>
              <ListItemButton>
                <ListItemIcon>
                  <SpeedOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItemButton>
            </ListItem>
            {hasDepartmentPermission && (
              <ListItem component={NavLink} to="/department" disablePadding sx={ListItemStyle}>
                <ListItemButton>
                  <ListItemIcon>
                    <LanOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Department" />
                </ListItemButton>
              </ListItem>
            )}
            {hasCompanyPermission || hasClientPermission ? (
              <>
                <ListItem disablePadding sx={ListItemStyle} className="dropdown">
                  <ListItemButton onClick={handleClientDropClick}>
                    <ListItemIcon>
                      <GroupOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Clients" />
                    {clientMenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={clientMenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={SubListItemStyle}>
                    {hasCompanyPermission && (
                      <ListItem component={NavLink} to="/company" disablePadding>
                        <ListItemButton>
                          <ListItemIcon>
                            <MeetingRoomOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Companies" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasClientPermission && (
                      <ListItem component={NavLink} to="/client" disablePadding>
                        <ListItemButton>
                          <ListItemIcon>
                            <HowToRegOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Users" />
                        </ListItemButton>
                      </ListItem>
                    )}
                  </List>
                </Collapse>
              </>
            ) : (
              ''
            )}
            {hasPaymentRequestPermission ||
            hasTransactionPermission ||
            hasCurrencyPermission ||
            hasUOMPermission ? (
              <>
                <ListItem disablePadding sx={ListItemStyle} className="dropdown">
                  <ListItemButton onClick={handleDropClick}>
                    <ListItemIcon>
                      <PaymentsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Payments" />
                    {menuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={menuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={SubListItemStyle}>
                    {hasCurrencyPermission && (
                      <ListItem disablePadding component={NavLink} to="/currency">
                        <ListItemButton>
                          <ListItemIcon>
                            <AttachMoneyOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Currency" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasUOMPermission && (
                      <ListItem disablePadding component={NavLink} to="/unit-of-measurement">
                        <ListItemButton>
                          <ListItemIcon>
                            <StraightenOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Unit of Measurement" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasPaymentRequestPermission && (
                      <ListItem disablePadding component={NavLink} to="/payment-request">
                        <ListItemButton>
                          <ListItemIcon>
                            <RequestPage />
                          </ListItemIcon>
                          <ListItemText primary="Payment Request" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasTransactionPermission && (
                      <ListItem disablePadding component={NavLink} to="/transaction">
                        <ListItemButton>
                          <ListItemIcon>
                            <Receipt />
                          </ListItemIcon>
                          <ListItemText primary="Transaction" />
                        </ListItemButton>
                      </ListItem>
                    )}
                  </List>
                </Collapse>
              </>
            ) : (
              ''
            )}
            {hasReportPermission && (
              <>
                <ListItem disablePadding sx={ListItemStyle} className="dropdown">
                  <ListItemButton onClick={handleReprtDropClick}>
                    <ListItemIcon>
                      <PaymentsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Reports" />
                    {reportMenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={reportMenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={SubListItemStyle}>
                    <ListItem disablePadding component={NavLink} to="/reports/summary">
                      <ListItemButton>
                        <ListItemIcon>
                          <RequestPage />
                        </ListItemIcon>
                        <ListItemText primary="Summary" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding component={NavLink} to="/reports/financial-year">
                      <ListItemButton>
                        <ListItemIcon>
                          <Receipt />
                        </ListItemIcon>
                        <ListItemText primary="Financial Year" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding component={NavLink} to="/reports/ageing">
                      <ListItemButton>
                        <ListItemIcon>
                          <PendingActions />
                        </ListItemIcon>
                        <ListItemText primary="Ageing" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Collapse>
              </>
            )}
            {hasUserPermission || hasRolesPermission ? (
              <>
                <ListItem disablePadding sx={ListItemStyle} className="dropdown">
                  <ListItemButton onClick={handleUserDropClick}>
                    <ListItemIcon>
                      <AdminPanelSettingsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Users & Roles" />
                    {userMenuOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={userMenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={SubListItemStyle}>
                    {hasUserPermission && (
                      <ListItem disablePadding component={NavLink} to="/user">
                        <ListItemButton>
                          <ListItemIcon>
                            <PersonOutlineOutlined />
                          </ListItemIcon>
                          <ListItemText primary="User Management" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasRolesPermission && (
                      <ListItem disablePadding component={NavLink} to="/roles-permissions">
                        <ListItemButton>
                          <ListItemIcon>
                            <ManageAccountsOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Roles and Permission" />
                        </ListItemButton>
                      </ListItem>
                    )}
                  </List>
                </Collapse>
              </>
            ) : (
              ''
            )}
            {/* {hasPermission && (
              <ListItem disablePadding sx={ListItemStyle} component={NavLink} to="/notifications">
                <ListItemButton>
                  <ListItemIcon>
                    <NotificationsNoneOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Notifications" />
                </ListItemButton>
              </ListItem>
            )} */}
            {hasAuditTrailPermission && (
              <ListItem disablePadding sx={ListItemStyle} component={NavLink} to="/audit-trial">
                <ListItemButton>
                  <ListItemIcon>
                    <UpdateOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Access Logs" />
                </ListItemButton>
              </ListItem>
            )}
            {hasAuditTrailPermission && (
              <ListItem disablePadding sx={ListItemStyle} component={NavLink} to="/email-logs">
                <ListItemButton>
                  <ListItemIcon>
                    <MarkEmailReadOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Mail Logs" />
                </ListItemButton>
              </ListItem>
            )}
            {hasAddressPermission ||
            hasMailPermission ||
            hasPaymentGatewayPermission ||
            hasBankPermission ||
            hasSignaturePermission ? (
              <>
                <ListItem disablePadding sx={ListItemStyle} className="dropdown">
                  <ListItemButton onClick={handleSettingClick}>
                    <ListItemIcon>
                      <SettingsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Settings" />
                    {settingOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>
                <Collapse in={settingOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={SubListItemStyle}>
                    {hasAddressPermission && (
                      <ListItem disablePadding component={NavLink} to="/settings" end>
                        <ListItemButton>
                          <ListItemIcon>
                            <SettingsApplicationsOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Office Address" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasMailPermission && (
                      <ListItem disablePadding component={NavLink} to="/settings/mail">
                        <ListItemButton>
                          <ListItemIcon>
                            <EmailOutlined />
                          </ListItemIcon>
                          <ListItemText primary="Mail Configuration" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasPaymentGatewayPermission && (
                      <ListItem disablePadding component={NavLink} to="/settings/payment">
                        <ListItemButton>
                          <ListItemIcon>
                            <RequestQuoteOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText primary="Payment Gateway" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasBankPermission && (
                      <ListItem disablePadding component={NavLink} to="/settings/bank">
                        <ListItemButton>
                          <ListItemIcon>
                            <AccountBalanceIcon />
                          </ListItemIcon>
                          <ListItemText primary="Bank Configuration" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {hasSignaturePermission && (
                      <ListItem disablePadding component={NavLink} to="/settings/signature">
                        <ListItemButton>
                          <ListItemIcon>
                            <DrawIcon />
                          </ListItemIcon>
                          <ListItemText primary="Signature Configuration" />
                        </ListItemButton>
                      </ListItem>
                    )}
                  </List>
                </Collapse>
              </>
            ) : (
              ''
            )}
          </List>
        </Scrollbars>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
          px: 1.5,
          background: '#f9fafc',
          height: '100%',
          minHeight: '100vh',
          width: `calc(100% - ${drawerWidth}px)`
        }}
      >
        <AppBar
          open={open}
          sx={{
            bgcolor: 'transparent'
          }}
        >
          <Toolbar
            sx={{
              bgcolor: '#ffffff',
              p: 1,
              px: '12px !important',
              boxShadow: 'none',
              minHeight: '80px !important',
              borderBottom: '1px solid rgba(0, 32, 93, 0.5)!important'
              // margin: '0 24px'
              // ...(!open && { margin: 0 }),
            }}
          >
            <IconButton
              color="white"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              sx={{
                borderRadius: '50%',
                backgroundColor: '#e6efff'
                //   marginRight: 5,
                //   ...(open && { display: "none" }),
              }}
            >
              {!open ? (
                <KeyboardDoubleArrowRightRounded
                  sx={{
                    fontSize: '20px',
                    color: '#1640d6'
                  }}
                />
              ) : (
                <KeyboardDoubleArrowLeftRounded
                  sx={{
                    fontSize: '20px',
                    color: '#1640d6'
                  }}
                />
              )}
            </IconButton>
            <Box sx={{ ml: 'auto' }}>
              {hasPermission && (
                <IconButton
                  onClick={handleClick}
                  size="large"
                  aria-label="show new notifications"
                  color="primary"
                >
                  <Badge badgeContent={notifyCount} color="error" showZero>
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
              )}
              <Button
                id="demo-customized-button"
                aria-controls={dropDownOpen ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={dropDownOpen ? 'true' : undefined}
                variant="text"
                disableElevation
                onClick={handleDropDownClick}
                endIcon={<ExpandCircleDownRounded />}
              >
                Welcome {userData?.name}
              </Button>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={dropDownOpen}
                onClose={handleDropDownClose}
                // onClick={handleClose}
                slotProps={{
                  background: 'red',
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1
                      },
                      '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0
                      }
                    }
                  }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem component={NavLink} to="/profile">
                  <ListItemIcon>
                    <PersonOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  Profile
                </MenuItem>
                <MenuItem onClick={handleChangePassword}>
                  <ListItemIcon>
                    <HttpsOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  Change Password
                </MenuItem>
                <Divider />
                <MenuItem
                  sx={{ fontSize: '14px', fontWeight: 700 }}
                  onClick={() => {
                    handleDropDownClose();
                    dispatch(AuthAction.logout(navigate));
                  }}
                >
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
        <DrawerHeader />
        <Header />
      </Box>
      {modalOpen === true ? (
        <ChangePassword openmodal={modalOpen} onCloseModal={() => setModalOpen(false)} />
      ) : (
        ''
      )}
      {notifyOpen === true ? (
        <Notifications
          notifyOpen={notifyOpen}
          apiResponse={notificationData}
          anchorE2={anchorE2}
          onCloseModal={() => setAnchorE2(null)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
Sidebar.propTypes = {
  hasPermission: PropTypes.bool.isRequired
};

export default Sidebar;
